import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React, { useCallback, useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { cloneDeep, debounce, set } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../redux/slices/treeSlice";
import graphQLSrc from "../../../assets/icons/graphql.gif";
import DynamicClauseValues from "./DynamicClauseValues";
import GraphQLQueryBuilder from "./GraphQLBuilder/GraphQLQueryBuilder";

function GraphQLProperties() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const dispatch = useDispatch();
  const [description, setDescription] = useState("");
  const [operationType, setOperationType] = useState(
    selectedNode?.OPERATION || "QUERY"
  );
  const [url, setUrl] = useState(selectedNode?.URL || "");
  const [openQueryBuilder, setOpenQueryBuilder] = useState(false);
  const operationTypeMenuItems = [
    "_GRAPHQL_QUERY_",
    "_GRAPHQL_MUTATION_",
    "_GRAPHQL_SUBSCRIPTION_",
  ].map((type) => (
    <MenuItem key={type} value={t(type)}>
      {t(type)}
    </MenuItem>
  ));
  const [graphQLVariables, setGraphQLVariables] = useState([])

  const submitChange = (field, value) => {
    const updatedData = eachDeep(cloneDeep(translatedData), (obj) => {
      if (obj?.key !== selectedNode.key) return;
      obj[field] = value;
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: rightTree.currentTab,
          data: obj,
        })
      );
    });
    dispatch(
      treeActions.setNewRightTreeTranslatedData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: updatedData,
      })
    );
  };

  const debounceChangeHandler = useCallback(debounce(submitChange, 300), [
    rightTree.tree,
  ]);

  useEffect(() => {
    setDescription(selectedNode?.DESCRIPTION || "");
    setOperationType(selectedNode?.OPERATION || "query");
    setUrl(selectedNode?.URL || "");
    const variables = selectedNode?.RECORD_DETAILS?.map((row, index) => {
      return {
        ...row.FIELD,
        };
    });
    setGraphQLVariables(variables || []);
  }, [selectedNode?.key]);

  return (
    <>
      <Stack spacing={"15px"} className="tp-segment">
        <FormControl className="width-100" variant="outlined" size="small">
          <TextField
            variant="outlined"
            size="small"
            label={t("LBL_DESC")}
            autoComplete="off"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              debounceChangeHandler("DESCRIPTION", e.target.value);
            }}
          />
        </FormControl>
        <FormControl className="width-100" variant="outlined" size="small">
          <Stack direction="row" spacing="4px">
            <TextField
              variant="outlined"
              size="small"
              label={t("LBL_URL")}
              value={url}
              className="width-100"
              onChange={(e) => {
                setUrl(e.target.value);
                debounceChangeHandler("URL", e.target.value);
              }}
            />
            <Button
              variant="outlined"
              size="small"
              onClick={() => setOpenQueryBuilder(true)}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <img src={graphQLSrc} alt="GraphQL" className="GRAPHQL" />
                {t("LBL_GraphQL_QUERY")}
              </div>
            </Button>
          </Stack>
        </FormControl>
        <FormControl className="width-100" variant="outlined" size="small">
          <InputLabel id="graphql-operation-type">
            {t("LBL_OPERATION_TYPE")}
          </InputLabel>
          <Select
            className="width-100"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                },
              },
            }}
            name="operationType"
            value={operationType}
            label={t("LBL_OPERATION_TYPE")}
            onChange={(e) => {
              setOperationType(e.target.value);
              debounceChangeHandler("OPERATION", e.target.value);
            }}>
            {operationTypeMenuItems}
          </Select>
        </FormControl>
        <Box className="width-100 height-100">
          <DynamicClauseValues dynamicClauses={graphQLVariables} caller="GraphQLProperties"/>
        </Box>
      
      </Stack>
      {openQueryBuilder && <GraphQLQueryBuilder open={openQueryBuilder} onClose={() => setOpenQueryBuilder(false)} />}
    </>
  );
}

export default GraphQLProperties;
